import { z } from 'zod';
/**
 * Pipeline stage names.
 */
export const PipelineStageSchema = z.enum(['chunk', 'embed', 'index']);
/**
 * Data source types for the pipeline.
 */
export const DataSourceSchema = z.enum([
    'kjv',
    'strongs',
    'cross-references',
    'halley',
    'mcgee',
    'chuck-smith',
]);
/**
 * Pipeline run status.
 */
export const PipelineRunSchema = z.object({
    id: z.string(),
    stage: PipelineStageSchema,
    source: DataSourceSchema,
    status: z.enum(['pending', 'running', 'completed', 'failed']),
    progress: z.number().int().nonnegative(),
    total: z.number().int().nonnegative(),
    startedAt: z.string().datetime().optional(),
    completedAt: z.string().datetime().optional(),
    error: z.string().optional(),
});
/**
 * Model task types for the router.
 */
export const ModelTaskSchema = z.enum([
    'bible-chat',
    'query-analysis',
    'embedding',
    'word-study',
    'validation',
    'study-generation',
    'refine',
]);
/**
 * Infrastructure health status.
 */
export const InfraHealthSchema = z.object({
    ollama: z.object({
        healthy: z.boolean(),
        missingModels: z.array(z.string()),
    }),
    chromadb: z.object({
        healthy: z.boolean(),
    }),
    timestamp: z.string().datetime(),
});
//# sourceMappingURL=pipeline-types.js.map